import { useEffect } from 'react'
import TracedLogo from '../design/TracedLogo'

// This is an unattended terminal: a human is not standing by to reload it.
// If a render error ever slips past the fixes elsewhere, self-heal rather
// than sit on a dead screen. The brass line fills over this same wait
// (tailwind `animate-recover`), so the screen reads as coming back.
export const RELOAD_AFTER_MS = 15000

/** Shown outside the translation provider, so it says nothing in words. */
export default function ErrorFallback() {
  useEffect(() => {
    const timer = setTimeout(() => window.location.reload(), RELOAD_AFTER_MS)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="relative flex h-full flex-col items-center justify-center overflow-hidden bg-night">
      <div className="pointer-events-none absolute h-[70vh] w-[70vh] rounded-full bg-brass-500/[0.14] blur-[100px]" />
      <TracedLogo pace="loop" className="relative h-[clamp(40px,9vh,96px)]" />
      <div className="relative mt-cfd-4 h-px w-[clamp(120px,22vw,320px)] overflow-hidden bg-white/10">
        <div className="h-full w-full origin-left bg-brass-500 motion-safe:animate-recover" />
      </div>
    </div>
  )
}
